import { v4 as uuidv4 } from "uuid";
import { makeAutoObservable, runInAction } from "mobx";
import { commonAxios } from "../../CommonAxios";

class CellStore {
  id = uuidv4();
  value = null; // default value
  popoverOpen = false; // renamed from popOver for clarity
  popoverAnchorEl = null;
  peopleEnrich = -1;
  constructor(value = {}) {
    // this.value = value?.value ?? "";
    this.value = value?.value;
    makeAutoObservable(this);
  }

  setValue(value) {
    this.value = value;
  }

  setObjValue(obj) {
    runInAction(() => {
      // this.value = obj?.value ?? "";
      this.value = obj?.value;
      this.peopleEnrich = obj?.peopleEnrich ?? -1;
    });
  }

  setEnrichIcon(value) {
    runInAction(() => {
      this.peopleEnrich = value ?? -1;
    });
  }

  // Getter for popover open state
  get isPopoverOpen() {
    return this.popoverOpen;
  }

  // Setter for popover open state
  setPopoverOpen(open) {
    this.popoverOpen = open;
  }

  // Getter for anchor element
  get getPopoverAnchorEl() {
    return this.popoverAnchorEl;
  }

  // Setter for anchor element
  setPopoverAnchorEl(element) {
    this.popoverAnchorEl = element;
  }

  get href() {
    return "https://www.google.com/s2/favicons?domain=" + this.value;
  }

  async updateRecordOnBlur(columnId, userId, tableId, rowId) {
    commonAxios(
      "/updateRecord",
      "POST",
      {},
      {
        userId,
        tableId,
        rowId,
        data: {
          [columnId]: this.value,
        },
      }
    );
  }
}

export default CellStore;
